import styled from 'styled-components';

/**
 * A bordered section with an action strip pinned to its bottom edge.
 *
 * Shared so the seat-status and feature sections of the Manage Users modal read as the same
 * kind of thing - each an independently saved block - and so the footer's negative margins
 * stay in step with the box padding they cancel.
 */
const BOX_PADDING = '16px';

export const SectionBox = styled.div`
  padding: ${BOX_PADDING};
  border: 1px solid ${({ theme }) => theme.colors.defaultGreyBorderColor};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
`;

/**
 * Sits flush against the box's bottom border: the negative margins cancel SectionBox's
 * padding on three sides, so the strip reaches the edges.
 */
export const SectionBoxFooter = styled.div`
  margin: 12px -${BOX_PADDING} -${BOX_PADDING};
  padding: 8px 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.defaultGreyBorderColor};
  border-radius: 0 0 4px 4px;
  background-color: ${({ theme }) => theme.colors.lightGreyBackground};

  /* the row inside supplies its own layout; the wrapper owns the spacing */
  & > * {
    margin: 0;
  }
`;
